class DeviceService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getDevices(params) {
    return this.apiService.get('/api/v1/devices', params);
  }

  deleteDevices(params) {
    return this.apiService.delete('/api/v1/devices', params);
  }

  createDevice(params) {
    return this.apiService.post('/api/v1/devices', params);
  }

  editDevice(params) {
    return this.apiService.put('/api/v1/devices', params);
  }

  sendNotifications(params) {
    return this.apiService.post('/api/v1/devices/send-notification', params);
  }
}

module.exports = DeviceService;